// ── „Wykluczone rejony (RE)" w portfelu ZE ───────────────────────────────────
// Pure helpers behind the portfolio's excluded-rejony filter. Kept out of
// ZETendersPortfolioPage so the matching rules can be unit-tested.

/** Rejony Dystrybucji ENERGA ukrywane z listy portfela. Wartości to nazwy miast rejonu
 *  (porównywane z polem `energa_rejon`). Wszystkie są domyślnie zaznaczone (patrz
 *  initial state strony), więc projekty z tych RE są od razu ukryte. */
export const EXCLUDABLE_REJONY = ["Kalisz", "Kępno"];

// NFD does not decompose ł, hence the extra replace (same approach as Sidebar search).
const COMBINING_MARKS = new RegExp("[\\u0300-\\u036f]", "g");

/** Lowercase, strip Polish diacritics, collapse punctuation/whitespace to single spaces:
 *  „  KĘPNO " → "kepno", „RE-Kępno" → "re kepno". */
export const foldRejon = (s: string) =>
  s
    .toLocaleLowerCase("pl")
    .normalize("NFD")
    .replace(COMBINING_MARKS, "")
    .replace(/ł/g, "l")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

/** Rdzeń nazwy bez końcowych samogłosek („kepno" → "kepn"), żeby trafiała też forma
 *  odmieniona, którą AI potrafi przepisać z pieczątki mimo polecenia o mianowniku
 *  („w Kępnie", „w Kaliszu"). */
const stem = (folded: string) => folded.replace(/[aeiouy]+$/, "") || folded;

/**
 * Czy rejon przetargu jest na liście wykluczonych. Porównanie bez wielkości liter
 * i polskich znaków; rdzeń nazwy musi zaczynać słowo, więc „RE Kępno" i „Kępnie"
 * pasują, a nazwa ukryta w środku innego słowa — nie. Brak rejonu (AI nie wykryło)
 * nigdy nie wyklucza.
 */
export function isRejonExcluded(rejon: string | null | undefined, excluded: string[]): boolean {
  if (!rejon || excluded.length === 0) return false;
  const words = ` ${foldRejon(rejon)}`;
  return excluded.some((x) => {
    const s = stem(foldRejon(x));
    return s !== "" && words.includes(` ${s}`);
  });
}
